import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _BuiltInDataTypes;
/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

/**
 * The type of data being accessed.
 */

export class BuiltInDataTypes {}
_BuiltInDataTypes = BuiltInDataTypes;
_defineProperty(BuiltInDataTypes, "STRING", {
  name: "string"
});
_defineProperty(BuiltInDataTypes, "SINGLE_LINE_PLAIN_STRING", {
  name: "single-line-plain-string",
  rawType: _BuiltInDataTypes.STRING
});
_defineProperty(BuiltInDataTypes, "MULTI_LINE_PLAIN_STRING", {
  name: "multi-line-plain-string",
  rawType: _BuiltInDataTypes.STRING
});
_defineProperty(BuiltInDataTypes, "PASSWORD", {
  name: "password",
  rawType: _BuiltInDataTypes.STRING
});
_defineProperty(BuiltInDataTypes, "SECRET", {
  name: "secret",
  rawType: _BuiltInDataTypes.STRING
});
_defineProperty(BuiltInDataTypes, "BOOLEAN", {
  name: "boolean"
});
_defineProperty(BuiltInDataTypes, "INTEGER", {
  name: "integer"
});
_defineProperty(BuiltInDataTypes, "DECIMAL", {
  name: "decimal"
});
_defineProperty(BuiltInDataTypes, "DATE", {
  name: "date"
});
_defineProperty(BuiltInDataTypes, "DATE_TIME", {
  name: "date-time"
});
_defineProperty(BuiltInDataTypes, "COLLECTION", {
  name: "collection"
});
_defineProperty(BuiltInDataTypes, "HTML_STRING", {
  name: "html-string",
  rawType: _BuiltInDataTypes.STRING
});
_defineProperty(BuiltInDataTypes, "MARKDOWN_STRING", {
  name: "markdown-string",
  rawType: _BuiltInDataTypes.STRING
});
_defineProperty(BuiltInDataTypes, "GUIDED_EXPRESSION_JSON", {
  name: "guided-expression-json",
  rawType: _BuiltInDataTypes.STRING
});
_defineProperty(BuiltInDataTypes, "ICON", {
  name: "icon",
  rawType: _BuiltInDataTypes.STRING
});
_defineProperty(BuiltInDataTypes, "COLOR", {
  name: "color",
  rawType: _BuiltInDataTypes.STRING
});
//# sourceMappingURL=DataType.js.map
